import * as React from 'react';
import DayPicker, { ClassNames, DayModifiers, DayPickerProps, Modifiers } from 'react-day-picker';
import * as moment from 'moment';
import { mapKeys } from 'lodash';

import DayTile from '../../DayTile';

import './styles.scss';
import { DefaultDateFormats } from '../../../constants/dateFormats';
import { useSelector } from 'react-redux';
import { getStreakInfo } from '../../StreakInfo/StreakLogic';

const calendarPickerClassNames: ClassNames = {
  container: 'CalendarDayPicker',
  wrapper: 'CalendarDayPicker-wrapper',
  interactionDisabled: 'CalendarDayPicker--interactionDisabled',
  navBar: 'CalendarDayPicker-navBar',
  navButtonNext: 'CalendarDayPicker-navButton CalendarDayPicker-navButton--next',
  navButtonPrev: 'CalendarDayPicker-navButton CalendarDayPicker-navButton--prev',
  navButtonInteractionDisabled: 'CalendarDayPicker-navButton--interactionDisabled',
  months: 'CalendarDayPicker-months',
  month: 'CalendarDayPicker-month',
  caption: 'CalendarDayPicker-caption',
  weekdays: 'CalendarDayPicker-weekdays',
  week: 'CalendarDayPicker-week',
  weekday: 'CalendarDayPicker-weekDay',
  weekdaysRow: 'CalendarDayPicker-weekDayRow',
  body: 'CalendarDayPicker-body',
  day: 'CalendarDayPicker-day',
  today: 'CalendarDayPicker-day--today',
  selected: 'CalendarDayPicker-day--selected',
  disabled: 'CalendarDayPicker-day--disabled',
  outside: 'CalendarDayPicker-day--outside',
  weekNumber: '',
  footer: '',
  todayButton: '',
};

interface ICalendarDayPickerProps extends DayPickerProps {
  expectedWordsCount: number;
  wordsCountToDays: { [key: string]: number };
}

function CalendarDayPicker(props: ICalendarDayPickerProps) {
  const streakInfo = useSelector(getStreakInfo);

  const renderDay = (day: Date, modifiers: DayModifiers): React.ReactNode => {
    const { expectedWordsCount, wordsCountToDays } = props;
    const dayTileModifiers: Modifiers = mapKeys(modifiers, (_, key: string = '') => {
      return key.replace('CalendarDayPicker-day', 'DayTile');
    }) as Modifiers;

    const isStreakRepaired = streakInfo.isStreakRepaired(day);

    return (
      <DayTile
        expectedWordsCount={expectedWordsCount}
        actualWordsCount={wordsCountToDays[moment(day).format(DefaultDateFormats.fullDate)]}
        day={moment(day).format(DefaultDateFormats.calendarDay)}
        modifiers={dayTileModifiers}
        isStreakRepaired={isStreakRepaired}
        value={day}
      />
    );
  };

  return <DayPicker classNames={calendarPickerClassNames} renderDay={renderDay} {...props} />;
}

CalendarDayPicker.defaultProps = {
  actualWordsCount: 0,
  wordsCountToDays: {},
};

export default CalendarDayPicker;



// WEBPACK FOOTER //
// ./src/components/Calendar/CalendarDayPicker/index.tsx